import { render, staticRenderFns } from "./VigilanteView.vue?vue&type=template&id=502e2a5a"
import script from "./VigilanteView.vue?vue&type=script&lang=js"
export * from "./VigilanteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports